import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/Users/xuxun/Documents/projects/xx/antd-utils/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0160ee1560bf4ffb223ab8272f1b0057.js')["default"];

var scope_1 = require('/Users/xuxun/Documents/projects/xx/antd-utils/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/10f9b10db7081244667ed3ac7a2b9a64.js')["default"];

var scope_2 = require('/Users/xuxun/Documents/projects/xx/antd-utils/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/66325c2f29ff306f47600d292b5b5db1.js')["default"];

var scope_3 = require('/Users/xuxun/Documents/projects/xx/antd-utils/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a7aac061e08933c4dc4fbb94b0b62af2.js')["default"];

var scope_4 = require('/Users/xuxun/Documents/projects/xx/antd-utils/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cc47336221bb81882b7ca01962f98d4b.js')["default"];

var scope_5 = require('/Users/xuxun/Documents/projects/xx/antd-utils/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js')["default"];

var scope_6 = require('/Users/xuxun/Documents/projects/xx/antd-utils/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f019bfa0326b5a188cd6adfb1a505314.js')["default"];

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}